import {SpaceProto} from "../space-proto";
import {NavigationButtonPosition, NavigationSectionType} from "../../navigation/@const";
import Navigation_ButtonGeneric from "../../../../layout/navigation/buttons/generic";
import {getNavigationPosition} from "../../navigation/functions/get-navigation-position";
import {navigationStructureOnClick} from "../../navigation/actions/navigation-structure-on-click";
import MainMenu_Users from "../../../../layout/menu/sections/users/menu-users";


export class SpaceMyAccount extends SpaceProto {

    constructor() {
        super(NavigationSectionType.MY_ACCOUNT)
        this.positionOptions = []

        this.title = "My Account"
    }

    // get enabled():boolean {
    //     return gd.ac.check.company.isUser(gd.companyId) && gd.ac.components.hasAccess('users')
    // }

    get navigationStructureConfig() {
        return {
            id                  : this.id,
            icon                : "i5-nav-users",
            iconActive          : "i5-nav-users-solid",
            hint                : "My Account",
            type                : NavigationSectionType.MY_ACCOUNT,
            renderComponent     : Navigation_ButtonGeneric,
            // menuComponent       : MainMenu_Users,
            // onClick             : navigationStructureOnClick,
            position            : NavigationButtonPosition.BOTTOM
        }

    }



}